<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">{{ pageTitle }}</h3>
          </div>
          <div class="box-body">

            <el-card class="box-card" shadow="never">
              <div class="query">
                <el-form :inline="true">
                  <el-form-item label="搜索">
                    <el-input v-model="query.keyword" clearable placeholder="输入名称搜索"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" :disabled="loading" @click="querySearch">查询</el-button>
                  </el-form-item>
                </el-form>
              </div>

              <el-table :data="list" border style="width: 100%" v-loading="loading">
                <el-table-column prop="name" label="企业名称"></el-table-column>
                <el-table-column prop="type_desc" label="企业类型"></el-table-column>
                <el-table-column prop="address" label="企业地址"></el-table-column>
                <el-table-column prop="auth_station_total" label="授权站点数量"></el-table-column>
                <el-table-column prop="auth_expire_at" label="授权到期时间"></el-table-column>
              </el-table>

              <div v-if="list.length > 0">
                <div style="height: 20px;"></div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :current-page="query.page"
                    :page-size="query.size"
                    :total="total"
                    @current-change="pageSelect"
                >
                </el-pagination>
              </div>

            </el-card>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      loading: false,
      query: {
        keyword: '',
        page: 1,
        size: 10
      },
      list: [],
      total: 0,
      canNext: false,
      nextPage: 1,
      typeList: [],
    };
  },
  computed: mapState({
    config: (state) => state.config,
    pageTitle: (state) => state.pageTitle,
  }),
  mounted() {
    const _this = this;
    _this.query = Object.assign(_this.query, _this.$route.query)
    _this.query.page = parseInt(_this.query.page);
    _this.query.size = parseInt(_this.query.size);
    _this.loading = true;
    _this.$store
        .dispatch('authInit', _this)
        .then(() => {
          _this.loadList();
        })
        .catch(() => {
          _this.loading = false;
        })
  },
  methods: {
    updateUrl() {
      const _this = this;
      const url = _this.$queryUrl(_this.$route.path, _this.query);
      _this.$router.replace({path: url});
    },
    querySearch() {
      const _this = this;
      _this.query.page = 1;
      _this.loading = true;
      _this.loadList();
    },
    pageSelect(page) {
      const _this = this;
      _this.query.page = parseInt(page);
      _this.loading = true;
      _this.loadList();
    },
    loadList() {
      const _this = this;
      _this.$apiAdmin.adminCustomList(_this.query)
          .then(res => {
            _this.loading = false;
            _this.list = res.list;
            _this.total = res.total;
            _this.canNext = res.can_next;
            _this.nextPage = res.next_page;
            _this.updateUrl();
          })
          .catch(err => {
            _this.loading = false;
            _this.updateUrl();
          })
    },
  }
}
</script>


<style scoped>
.custom-tree-node {
  display: flex;
  justify-content: space-between;
}

.custom-tree-node-name {
  width: 400px;
}
</style>